import React from "react";
import { VscAccount } from "react-icons/vsc";
import { IconContext } from "react-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutAdmin } from "../../store";
import { url } from "../../configlink";
import { useState } from "react";

const AdminHeader = () => {

  let adminName = useSelector((state) => state.userAdmin.userAdmin )
  let dispatch = useDispatch()
  let navigate = useNavigate()

  let [showResetPassword, setShowResetPassword] = useState(false)

  let [pwd, setPwd] = useState('')
  let [pwdConfirm, setPwdConfirm] = useState('')
  let [oldPwd, setOldPwd] = useState('')


  function logoutadmin(){
    let conf = window.confirm("Do you want to log out?")

    if(conf){
      dispatch(logoutAdmin());
      try {
        fetch(`${url}/api/auth/admin_logout`, {
          method: "POST",
		credentials: "include", // Send cookies along with the request
		headers: {
			'acgt-admin': adminName
		},
        })
        .then(res => res.json())
        .then(data => {
          if(data.message==='Logout successful'){
            localStorage.removeItem('token_expiry')
            navigate("/adminlogin");
          }
        })
      } catch (error) {
        console.error(error);
        
      }
      
    }
  }


  const [errors, setErrors] = useState({});

  function validate(){
     const newErrors = {};
    
    if (!oldPwd) newErrors.oldPwd = 'Please enter';
    
    if (!pwd) {
      newErrors.pwd = 'Please enter';
    }
    else if(pwd === oldPwd){
      newErrors.pwd = 'Enter new password';
    }
        
    if (!pwdConfirm) {
      newErrors.pwdConfirm = 'Please enter';
    }
    else if(pwdConfirm !== pwd){
      newErrors.pwdConfirm = 'Passwords do not match';
    }
    
    return newErrors;
  }

  function cancelPWChange(){
      setOldPwd('')
      setPwd('')
      setPwdConfirm('')
      setShowResetPassword(false)
  }

  function changeAdminPw(){

    const validationErrors = validate();
    // console.log(validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {

    let d2 = {
      currentPw: oldPwd,
      newPw: pwd,
    }

    // console.log("d2", d2);

    try {
        fetch(`${url}/api/auth/updateAdminPw?adminName=${adminName}`, {
          method: "PUT",
          credentials: "include", // Send cookies along with the request
          headers: {
            'Content-Type':'application/json'
          },
          body: JSON.stringify(d2)
        })
        .then(res => res.json())
        .then(data => {
          if(data.message==='success'){
           alert("Success")
           setOldPwd('')
           setPwd('')
           setPwdConfirm('')
           setShowResetPassword(false)
          }
          else{
            alert(data.message)
          }
        })
      } catch (error) {
        console.error(error);
        
      }
    
  }
  }


  return (
    <>
      <header className='px-10 border-b-2 border-gray-200'>
        
        <div  className='flex justify-between items-center'>
          <div className='flex items-center'>
            <img
              className='w-[260px] h-auto my-4'
              src='/images/acgt-logo-2022.png'
              alt='acgt-logo'
            />
          </div>

          <div className="flex flex-col items-end gap-[10px] pb-[20px]">
            <div className='flex items-center justify-end w-[440px]'>
              <IconContext.Provider
                value={{
                  className:
                    "text-2xl text-[var(--color-primary-purple)] mx-2 h-8 w-8",
                }}
              >
                <VscAccount />
              </IconContext.Provider>
              <p className='text-center font-bold text-[var(--color-primary-purple)] m-0'>
                {`${adminName}`}
              </p>
            </div>

            {/* <div className="flex items-center gap-[30px]"> */}
              <button className="ml-8 font-semibold text-white bg-green-700 px-2 rounded-md" onClick={() => setShowResetPassword(true)}>Reset Password</button>
              <button className="ml-8 font-semibold underline" onClick={logoutadmin}>Logout</button>
            {/* </div> */}
          </div>
        </div>
        {showResetPassword && 
        <div className="flex items-center gap-[30px] justify-center pb-8">
            <div className="flex items-center gap-[5px]">
              <label>Current Password:</label>
              <div className="flex flex-col relative">
                <input className="border border-1 px-2 text-[14px] py-1" type="text" value={oldPwd} 
                onChange={(e) => {
                  setErrors({...errors, oldPwd: ''})
                  setOldPwd(e.target.value)}
                }/>
                {errors.oldPwd && 
                  <span className='absolute top-[30px] text-[14px] text-red-500 font-bold'>{errors.oldPwd}</span>
                }
              </div>
            </div>
            <div className="flex items-center gap-[5px]">
              <label>New Password:</label>
              <div className="flex flex-col relative">
                <input className="border border-1 px-2 text-[14px] py-1" type="text" value={pwd} 
                onChange={(e) => {
                  setErrors({...errors, pwd: ''})
                  setPwd(e.target.value)}
                }/>
                {errors.pwd && 
                  <span className='absolute top-[30px] text-[14px] text-red-500 font-bold'>{errors.pwd}</span>
                }
              </div>
            </div>
            <div className="flex items-center gap-[5px]">
              <label>Confirm Password:</label>
              <div className="flex flex-col relative">
                <input className="border border-1 px-2 text-[14px] py-1" type="text" value={pwdConfirm} 
                onChange={(e) => {
                  setErrors({...errors, pwdConfirm: ''})
                  setPwdConfirm(e.target.value)}
                }/>
                {errors.pwdConfirm && 
                  <span className='absolute top-[30px] text-[14px] text-red-500 font-bold'>{errors.pwdConfirm}</span>
                }
              </div>
            </div>
            <button 
            className="text-white bg-[var(--color-primary-purple)] px-4 rounded-md"
            onClick={() => changeAdminPw()}
            >Submit</button>
            <button 
            className="text-white bg-gray-500 px-4 rounded-md"
            onClick={() => cancelPWChange()}
            >Cancel</button>
        {errors.changePwError && 
          <span className='text-[14px] text-red-500 font-bold'>{errors.changePwError}</span>
        }
        </div>
        
        }
      </header>
    </>
  );
};

export default AdminHeader;
